import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  LayoutDashboard,
  Users,
  Clock,
  ThermometerSun,
  Palmtree,
  CalendarDays,
  Mail,
  BookOpen,
  ShoppingCart,
  Package,
  Building2,
  BarChart3,
  UserCog,
  Settings,
  Bot,
  AlertTriangle,
  Wrench,
  Calculator,
  Receipt,
  FileOutput,
  FolderArchive,
  Bug,
  DraftingCompass,
} from 'lucide-react'
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from '@/components/ui/command'

const pages = [
  { name: 'Dashboard', path: '/admin', icon: LayoutDashboard },
  { name: 'Mängel', path: '/admin/maengel', icon: AlertTriangle },
  { name: 'Bauvorhaben', path: '/admin/bauvorhaben', icon: Building2 },
  { name: 'Bautagebücher', path: '/admin/bautagebuch', icon: BookOpen },
  { name: 'Bestellungen', path: '/admin/bestellungen', icon: ShoppingCart },
  { name: 'Produkte', path: '/admin/produkte', icon: Package },
  { name: 'Geräte', path: '/admin/geraete', icon: Wrench },
  { name: 'Mitarbeiter', path: '/admin/mitarbeiter', icon: Users },
  { name: 'Zeiterfassung', path: '/admin/zeiterfassung', icon: Clock },
  { name: 'Krankmeldungen', path: '/admin/krankmeldungen', icon: ThermometerSun },
  { name: 'Urlaub', path: '/admin/urlaub', icon: Palmtree },
  { name: 'Stundenzettel', path: '/admin/stundenzettel', icon: CalendarDays },
  { name: 'Buchhaltung', path: '/admin/buchhaltung', icon: Receipt },
  { name: 'Ausgangsrechnungen', path: '/admin/ausgangsrechnungen', icon: FileOutput },
  { name: 'Dokumentenablage', path: '/admin/dokumentenablage', icon: FolderArchive },
  { name: 'Kalkulation', path: '/admin/kalkulation', icon: Calculator },
  { name: 'DWG-Editor', path: '/dwg/', icon: DraftingCompass },
  { name: 'Nachrichten', path: '/admin/nachrichten', icon: Mail },
  { name: 'Berichte', path: '/admin/berichte', icon: BarChart3 },
  { name: 'K.I.', path: '/admin/ki', icon: Bot },
  { name: 'Bug Tracker', path: '/admin/bug-tracker', icon: Bug },
  { name: 'Benutzerverwaltung', path: '/admin/benutzerverwaltung', icon: UserCog },
  { name: 'Einstellungen', path: '/admin/einstellungen', icon: Settings },
]

export function CommandMenu() {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        setOpen((open) => !open)
      }
    }
    document.addEventListener('keydown', down)
    return () => document.removeEventListener('keydown', down)
  }, [])

  const runCommand = (path: string) => {
    setOpen(false)
    // eigene Seiten außerhalb der WebUI-SPA (DWG-Editor) öffnen in einem neuen Tab
    if (!path.startsWith('/admin')) window.open(path, '_blank', 'noopener')
    else navigate(path)
  }

  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Seite suchen..." />
      <CommandList>
        <CommandEmpty>Keine Ergebnisse.</CommandEmpty>
        <CommandGroup heading="Seiten">
          {pages.map((page) => (
            <CommandItem
              key={page.path}
              value={page.name}
              onSelect={() => runCommand(page.path)}
            >
              <page.icon className="mr-2 h-4 w-4" />
              <span>{page.name}</span>
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  )
}
